/** "ABC Trading" → "AT" */
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

/** "ABC Trading Co." → "abc-trading-co" (used in addresses like /customers/abc-trading-co) */
export const slug = (name: string) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

/** "12 KB", "1.4 MB"; a file that is not in the vault any more has no size */
export const fileSize = (bytes: number | null) =>
  bytes === null
    ? 'not found'
    : bytes < 1_000_000
      ? `${Math.max(1, Math.round(bytes / 1000))} KB`
      : `${(bytes / 1_000_000).toFixed(1)} MB`;
